import { CandidateGdprTab } from '@/features/recruitment/components/candidate-gdpr-tab';
import { useCandidate } from '@/hooks/use-candidates';
import { usePermission } from '@/lib/permissions';
import { createFileRoute } from '@tanstack/react-router';
import { ShieldAlert } from 'lucide-react';

export const Route = createFileRoute('/recruitment/candidates_/$id/gdpr')({
  component: GdprTab,
});

function GdprTab() {
  const { id } = Route.useParams();
  const canManage = usePermission('recruitment.candidates.gdpr');
  const { data, isLoading, error } = useCandidate(id);

  if (!canManage) {
    return (
      <div className="flex flex-col items-center rounded-lg border border-dashed border-border bg-muted/30 p-8 text-center">
        <ShieldAlert className="h-8 w-8 text-muted-foreground/60" aria-hidden />
        <p className="mt-2 text-sm font-medium text-foreground">GDPR data is restricted</p>
        <p className="mt-1 max-w-md text-xs text-muted-foreground">
          You need the <span className="font-mono">recruitment.candidates.gdpr</span> permission to
          view consent history, manage requests, or anonymise this candidate. Contact an HR admin.
        </p>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="rounded-md border border-border bg-background p-4 text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="rounded-md border border-destructive/40 bg-destructive/10 p-4 text-sm text-destructive">
        Failed to load candidate.
      </div>
    );
  }

  return <CandidateGdprTab candidate={data} />;
}
